// extracted by mini-css-extract-plugin
export default {"wrapper":"eg78gf","wrapper--mobile":"KukZdz","message":"GwYYbn"};